import type { ComponentProps, FC } from 'react';
import { createContext, useContext } from 'react';

type ModalContextType = {
  open?: boolean;
  modalWidth?: string;
  modalMaxWidth?: string;
  showCloseButton?: boolean;
  closeOnBackdropClick?: boolean;
  onClose?: () => void;
  className?: string;
  priorityOverride?: number;
  position?: 'end' | 'center';
  maxHeight?: string;
  height?: string;
  overflow?: boolean;
};

const ModalContext = createContext<ModalContextType>({ open: false, overflow: true });
export const useModal = (): ModalContextType => useContext(ModalContext);

export const ModalContextProvider: FC<ComponentProps<typeof ModalContext.Provider>> = (props) => {
  const { value, children } = props;
  const parentModal = useModal();
  const priority = value?.priorityOverride ?? (parentModal.priorityOverride ? parentModal.priorityOverride + 10 : null) ?? 0;

  return <ModalContext.Provider value={{ ...value, priorityOverride: priority }}>{children}</ModalContext.Provider>;
};

export const ModalContextConsumer = ModalContext.Consumer;
